export default {
  state: {
    document: {}
  },
  actions: {
    setDocument (context, document) {
      context.commit('pushDocument', document)
    }
  },
  mutations: {
    pushDocument (state, document) {
      if (state.document.length) {
        state.document = {}
      }
      state.document = Object.assign({}, document)
    }
  }
}
